import { render, staticRenderFns } from "./MeteringDetached.vue?vue&type=template&id=36cd8be5"
import script from "./MeteringDetached.vue?vue&type=script&lang=js"
export * from "./MeteringDetached.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports